import { Customer } from "../types/customer"; 
import { createApiStore } from "./genericStore";
import api from "../service/api"; // 🌟 Kendi api instance'ın

const useCustomerBaseStore = createApiStore<Customer>("/account");

export const useCustomerStore = () => {
    const store = useCustomerBaseStore();

    return {
        ...store,

        exportExcel: async (type: "template" | "all") => {
            try {
                const endpoint = type === "template" 
                    ? "/excel/account/export?template=true" 
                    : "/excel/account/export";

                // 🌟 Kendi api instance'ını responseType ile tetikliyoruz
                const response = await api.get(endpoint, {
                    responseType: "arraybuffer", // veya "blob"
                    headers: { "x-global-load": "true" }
                });

                // 💡 INTERCEPTOR KORUMASI: 
                // Eğer interceptor'ın response.data'yı soyup fırlatıyorsa 'response' değişkeni doğrudan arraybuffer olur.
                // Eğer ham response objesi dönüyorsa 'response.data' üzerinden veriyi alırız.
                const rawData = (response as any).data ? (response as any).data : response;

                // Gelen binary datayı temiz bir Blob haline getiriyoruz
                const blob = new Blob([rawData], { 
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
                });
                
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                
                const fileName = type === "template" ? "Cari_Yukleme_Sablonu.xlsx" : "Cari_Listesi_Export.xlsx";
                link.setAttribute("download", fileName);
                
                document.body.appendChild(link);
                link.click();
                
                // Bellek optimizasyonu
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error("Excel dışarı aktarılırken hata oluştu:", error);
                throw error;
            }
        },

        importExcel: async (file: File) => {
            try {
                const formData = new FormData();
                formData.append("file", file);

                const response = await api.post("/excel/account/import", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                });

                await store.fetchDataDynamic();
                return response.data;
            } catch (error) {
                console.error("Excel içeri aktarılırken hata oluştu:", error);
                throw error;
            }
        }
    };
};